<template>
  <div style="width: 100%;" :style="{ height: height }">
    <canvas class="px-2" ref="canvasRef"></canvas>
  </div>
</template>

<script setup>
import { onMounted, watch, onBeforeUnmount, ref } from 'vue';
import { Chart, Title } from 'chart.js';
Chart.register(Title);

const props = defineProps({
  chartData: { type: Object, default: () => ({ labels: [], datasets: [] }) },
  options:   { type: Object, default: () => ({}) },
  chartType: { type: String, default: 'line' },
  height:    { type: String, default: '500px' },
  embedded:  { type: Boolean, default: false }
});

const canvasRef = ref(null);
let chartInstance = null;

const renderChart = (titleOverride = null) => {
  if (!canvasRef.value || !props.chartType) return;
  chartInstance?.destroy();
  chartInstance = null;

  const finalOptions = {
    ...props.options,
    plugins: {
      ...props.options.plugins,
      title: {
        ...props.options.plugins?.title,
        display: props.embedded && !!titleOverride,
        text: titleOverride ?? '',
      }
    },
    scales: {
      ...props.options.scales,
      yLeft: {
        ...props.options.scales?.yLeft,
        title: {
          ...props.options.scales?.yLeft?.title,
          font: { size: props.embedded ? 10 : 16 },
        }
      },
      ...(props.options.scales?.yRight ? {
        yRight: {
          ...props.options.scales.yRight,
          title: {
            ...props.options.scales.yRight.title,
            font: { size: props.embedded ? 10 : 16 },
          }
        }
      } : {})
    }
  };

  chartInstance = new Chart(canvasRef.value.getContext('2d'), {
    type: props.chartType,
    data: props.chartData,
    options: finalOptions,
  });
};

onBeforeUnmount(() => {
  chartInstance?.destroy();
  chartInstance = null;
});
onMounted(() => {
  renderChart();
});

watch(
    () => [props.chartData, props.chartType],
    () => {
      renderChart();
    },
    { deep: true }
);
defineExpose({ renderChart });
</script>